import {
    useQueryClient,
    useMutation,
    UseMutationResult,
} from '@tanstack/react-query'
import { IRuleSet } from '../../interfaces'
import { updateRuleSet } from '../../../../services/dtServices'

export const useUpdateRuleSetName = (
    orgId: string,
    entityId: string,
): UseMutationResult<
    Awaited<ReturnType<typeof updateRuleSet>>,
    Error,
    IRuleSet
> => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (updatedRuleSet: IRuleSet) => {
            const { id, name, isDefault } = updatedRuleSet
            return updateRuleSet(orgId, id, name, isDefault)
        },
        onMutate: (updatedRuleSet: IRuleSet) => {
            queryClient.setQueryData(
                ['rulesets', orgId, entityId],
                (prevRuleSets: any) =>
                    prevRuleSets?.data?.map((ruleSet: IRuleSet) =>
                        ruleSet.id === updatedRuleSet.id
                            ? updatedRuleSet
                            : ruleSet,
                    ) as IRuleSet[],
            )
        },
        //refetch rules after mutation,
        onSettled: () =>
            queryClient.invalidateQueries({
                queryKey: ['rulesets', orgId, entityId],
            }),
    })
}
